const elements = {
  videos: document.querySelectorAll(".js-video"),
};
let video;
let APILoaded = false;
const active = "is-active";

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

function createVideo(element) {
  const videoConfig = {
    id: element.querySelector(".js-video-player").id,
    element: element,
    videoId: element.dataset.videoId,
    loaded: false,
    play: element.querySelector(".js-video-button"),
  };

  videoConfig.play.addEventListener("click", () => {
    video = videoConfig;

    if (!APILoaded) return loadAPI();
    loadVideo();
  });
}

function loadAPI() {
  const tag = document.createElement("script");

  tag.src = "https://www.youtube.com/iframe_api";

  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function onYouTubeIframeAPIReady() {
  APILoaded = true;
  loadVideo();
}

function loadVideo() {
  const player = new YT.Player(video.id, {
    videoId: video.videoId,
    playerVars: {
      playsinline: 1,
    },
    events: {
      onReady: onPlayerReady,
    },
  });
}

function onPlayerReady(event) {
  video.element.classList.add(active);
  event.target.playVideo();
  video.loaded = true;
}

function init() {
  if (elements.videos.length) {
    elements.videos.forEach(createVideo);
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/developers/video/video.js